<template>
  <div id="shiori-about">
    <div id="about-boxes">
      <div class="about-box">
          <div class="kihon" v-for="(aboutObject, index) in aboutObjects" :key="aboutObject.comment">
            <div>
              <p class="kihon-a">[{{ aboutObject.title }}]</p>
              <div class="kihon-btns">
                <button @click="editObject(index)"><i class="fas fa-pen fa-fw"></i></button>
                <button @click="deleteObject(index)"><i class="fas fa-trash-alt fa-fw"></i></button>
              </div>
            </div>
            <pre class="kihon-b">{{ aboutObject.comment }}</pre>
          </div>
      </div>
      <div class="about-add-btn-box">
        <button class="about-add-btn" @click="maskActive">追加</button>
      </div>
    </div>
    <MovePageBtn v-show="spWidth" 
    :last-page="{name:movePage.name2, link:movePage.link2}" 
    :next-page="{name:movePage.name, link:movePage.link}"></MovePageBtn>
    <MaskBox v-show="maskOn" ></MaskBox>
    <InputAbout v-show="maskOn" 
    @cancel="maskActive" 
    @new-shiori-about="addNewObject"
    @edit-object="replaceObject"></InputAbout>
  </div>
</template>

<script>
  import InputAbout from './InputBoxes/InputAbout1.vue';

export default {
  props: {
    spWidth: {
      type: Boolean,
      required: true
    },
  },
  components: {
    InputAbout
  },
  data() {
    return {
      maskOn: false,
      movePage: {
        name: "持ち物",
        link: "/items",
        name2: "タイトル",
        link2: "/",
      },
      newObject: {},
    }
  },
  computed: {
    aboutObjects: {
      get() {
        return this.$store.getters.aboutObjects;
      },
      set(value) {
        this.$store.commit('aboutObjects', value);
      }
    },
    editIndexA: {
      get() {
        return this.$store.getters.editIndexA;
      },
      set(value) {
        this.$store.commit('editIndexA', value);
      }
    },
    editModeA: {
      get() {
        return this.$store.getters.editModeA;
      },
      set(value) {
        this.$store.commit('editModeA', value);
      }
    },
    changeHeadTitle: {
      get() {
        return this.$store.getters.changeHeadTitle;
      },
      set(value) {
        this.$store.commit('changeHeadTitle', value);
      }
    },
  },
  methods: {
    maskActive() {
      this.maskOn = !this.maskOn;
      this.editModeA  = false;
      this.editIndexA = "";
    },
    addNewObject(inputAboutTitle, inputAboutComment) {
      this.newObject = {title:inputAboutTitle, comment:inputAboutComment};
      this.aboutObjects = [...this.aboutObjects, this.newObject];
      console.log(this.aboutObjects);
      this.maskOn = !this.maskOn;
      this.editModeA  = false;
      this.editIndexA = "";

    },
    deleteObject(index) {
      const ret = confirm("削除してもよろしいですか？")
      if(ret === true) {
        this.aboutObjects.splice(index, 1);
      } else {
        return;
      }
    },
    editObject(index) {
      this.maskOn = !this.maskOn;
      this.editIndexA = index;
      this.editModeA = true;
    },
    replaceObject(inputAboutTitle, inputAboutComment) {
      this.aboutObjects[this.editIndexA].title = inputAboutTitle;
      this.aboutObjects[this.editIndexA].comment = inputAboutComment;
      this.maskOn = !this.maskOn;
      this.editModeA  = false;
      this.editIndexA = "";
    }
  },
} 
</script>
